import { LanguageSwitcher } from '@/components/atoms';
import Avatar from '@/images/avatar/avatar.png';
import { ACTION_AUTH } from '@/redux/actions';
import PATH from '@/routes/path';
import { HELPERS } from '@/utils';
import { Popover } from '@headlessui/react';
import { setDefaultOptions } from 'date-fns';
import { enUS, id } from 'date-fns/locale';
import i18n from 'i18next';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { Link, useHistory } from 'react-router-dom';

const locales = { en: enUS, id };

export const HeaderButtonProfile = ({ authProfile, desktopMode }) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const [activeLanguage, setActiveLanguage] = useState(i18n.language);

  const handleSwitchLanguage = (lang) => {
    setDefaultOptions({ locale: locales[lang] });
    i18n.changeLanguage(lang);
  };

  const handleLogout = () => {
    dispatch(ACTION_AUTH.logout());

    HELPERS.GA.reset();
    history.push(PATH.HOME);
  };

  useEffect(() => setActiveLanguage(i18n.language), [i18n.language]);

  const className = desktopMode ? '' : 'absolute right-4 inset-y-0';

  return (
    <Popover className="flex items-center">
      <Popover.Button onClick={() => {}} type="button">
        <div className="flex items-center space-x-2">
          <img
            className="object-cover object-top w-12 h-12 rounded-full outline outline-4 outline-gray-200"
            src={authProfile?.avatar_url || Avatar}
            alt="Avatar"
          />
        </div>
      </Popover.Button>
      <Popover.Panel className="absolute right-0 z-10 w-full text-sm bg-white border-t shadow-md md:border-0 md:overflow-hidden md:rounded-lg md:w-80 top-20">
        {({ close }) => (
          <>
            <div className="flex items-center gap-2 p-4">
              <img
                className="object-cover object-top rounded-full w-11 h-11"
                src={authProfile?.avatar_url || Avatar}
                alt="Avatar"
              />
              <div>
                <div className="font-semibold">{authProfile?.name}</div>
                <div className="font-light text-gray-600">{authProfile?.email}</div>
              </div>
            </div>
            <hr />
            <Link
              className="inline-block w-full px-4 py-3 hover:bg-gray-100"
              to={PATH.PROFILE}
              onClick={(e) => close()}
            >
              {t('see_profile')}
            </Link>
            <hr />
            <div className="px-4 py-3 space-y-3">
              <div>Bahasa</div>
              <div className="space-y-2">
                {LanguageSwitcher.languageOptions.map(({ value, label, description }) => (
                  <div key={value} className="flex items-center gap-1.5" htmlFor={`#${label}`}>
                    <input
                      checked={activeLanguage === value}
                      id={label}
                      type="radio"
                      name="language"
                      value={value}
                      className="w-4 h-4 ring-secondary"
                      onChange={() => handleSwitchLanguage(value)}
                    />
                    <label className="flex items-center gap-1 cursor-pointer" htmlFor={label}>
                      {description}
                    </label>
                  </div>
                ))}
              </div>
            </div>
            <hr />
            <button
              className="inline-block w-full px-4 py-3 text-left hover:bg-gray-100"
              type="button"
              onClick={handleLogout}
            >
              {t('auth_logout')}
            </button>
          </>
        )}
      </Popover.Panel>
    </Popover>
  );
};
